import ClientDialog from './ClientDialog';

export {
  ClientDialog,
}



// WEBPACK FOOTER //
// ./src/components/admin/Clients/Dialog/index.js